<template>
  <div
    class="card-description"
    :class="[{ 'card-description--has-background': isShowingBackground }]"
    :style="`background-color: ${backgroundColor}`"
  >
    <div class="card-description__title">{{ productName }}</div>
    <div v-if="!isSummaryHidden" class="card-description__summary">
      {{ shortDescription }}
    </div>
    <div class="card-description__colors">{{ colorCount }} {{ $t(`product.${colorKey}`) }}</div>
    <div class="card-description__price">
      {{ productPrice }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { formatToCurrency } from '@/helpers/currency-formatter'

export default {
  name: 'CardDescription',
  props: {
    backgroundColor: {
      type: String,
    },
    card: {
      type: Object,
      required: true,
    },
    productName: {
      type: String,
    },
    isShowingBackground: {
      type: Boolean,
      default: false,
    },
    isSummaryHidden: {
      type: Boolean,
      default: false,
    },
    isGiftCardProduct: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState({
      currency: state => state.store.currency,
      locale: state => state.page.locale,
    }),

    colorCount() {
      return this.card?.variants?.length
    },

    colorKey() {
      return this.colorCount > 1 ? 'colors' : 'color'
    },

    priceWithCurrency() {
      const amount = Number(this.card.price)
      return this.card.price !== undefined
        ? formatToCurrency(amount, this.locale, this.currency)
        : ''
    },

    shortDescription() {
      return this.card.productData?.shortDescription || ''
    },

    productPrice() {
      return this.isGiftCardProduct
        ? this.$t('starting_from_price', {
            startingPrice: this.priceWithCurrency,
          })
        : this.priceWithCurrency
    },
  },
}
</script>

<style lang="scss" scoped>
@import './CardDescription';
</style>

<i18n src="@/locales/card_description.json">
</i18n>
